// Utility to enrich an array of product search/listing items with Bold Product Options
// Each item expected shape: { node: { id: 'gid://shopify/Product/...' }, boldProductOptions: ['0', {}] }
// Returns a new array with any items that have actual option sets updated to structure: [indexKey, optionProduct]
// api must supply getProductAttribute(productNumericId) resolving to { option_product: { option_sets: [...] } }

export async function enrichProductsWithBoldOptions(products, api) {
    if (!Array.isArray(products) || products.length === 0) return products;

    const needsEnrichment = (p) => {
        const bpo = p.boldProductOptions;
        if (!bpo) return true;
        const optsObj = bpo[1];
        if (!optsObj || typeof optsObj !== 'object') return true;
        if (!Array.isArray(optsObj.option_sets) || optsObj.option_sets.length === 0) return true;
        return false;
    };

    if (!products.some(needsEnrichment)) return products;

    const enriched = await Promise.all(
        products.map(async (p, idx) => {
            if (!needsEnrichment(p)) return p;
            try {
                const node = p.node || p;
                const prodIdParsed = node?.id?.split('/')?.pop();
                if (!prodIdParsed) return p;
                const attr = await api.getProductAttribute(prodIdParsed);
                const optionProduct = attr?.option_product;
                if (optionProduct && optionProduct.option_sets?.length > 0) {
                    return { ...p, boldProductOptions: [String(idx), optionProduct] };
                }
            } catch (_) {
                // ignore per-product errors
            }
            return p;
        })
    );

    return enriched;
}

export default enrichProductsWithBoldOptions;
